import { createFileRoute } from '@tanstack/react-router';

import { PageShell } from '@/components/app/page-shell';
import { MusicLibrary } from '@/features/music/components/music-library';

export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/marketing/music/'
)({
  component: MusicPage,
});

function MusicPage() {
  return (
    <>
      <title>Music | Borrah</title>
      <PageShell>
        <MusicLibrary />
      </PageShell>
    </>
  );
}
